import { render, staticRenderFns } from "./fjlist.vue?vue&type=template&id=10022f44"
import script from "./fjlist.vue?vue&type=script&lang=js"
export * from "./fjlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports